import {pwaClient} from './graphql_clients.ts';
import {FetchResult, gql} from '@apollo/client';
import {AvailabilitiesQuery, AvailableTimesQuery, CreateAppointmentMutation, LeadInput} from '../gql/pwa/graphql.ts';
import {format} from 'date-fns';
import {pwaRequestHeaders} from '../support/network.ts';

const AVAILABILITIES_QUERY = gql`
    query Availabilities(
        $locationId: Int
        $start: String
        $end: String
        $activity: String
        $replacementVehicle: String
        $extraJobs: [String]
    ) {
        locations(id: $locationId) {
            specialties {
                id
                name
                image_url
                availabilities(
                    start: $start
                    end: $end
                    activity: $activity
                    replacement_vehicle: $replacementVehicle
                    extra_jobs: $extraJobs
                ) {
                    date
                    availability
                    __typename
                }
                activities {
                    id
                    name
                    type
                    __typename
                }
                replacement_vehicles {
                    id
                    name
                    __typename
                }
                __typename
            }
            __typename
        }
    }
`;

const AVAILABLE_TIMES_QUERY = gql`
    query AvailableTimes($locationId: Int, $date: String!, $activity: String!, $extraJobs: [String]) {
        locations(id: $locationId) {
            specialties {
                id
                available_times(date: $date, activity: $activity, extra_jobs: $extraJobs)
                __typename
            }
            __typename
        }
    }
`;

const CREATE_APPOINTMENT = gql`
    mutation CreateAppointment($lead: LeadInput!) {
        createLead(lead: $lead) {
            id
            __typename
        }
    }
`;

export class Planner {
    static async availabilities(
        locationId: number,
        start: Date,
        end: Date,
        activity?: string | null,
        replacementVehicle?: string | null,
        extraJobs?: string[],
    ) {
        return await pwaClient.query<AvailabilitiesQuery>({
            query: AVAILABILITIES_QUERY,
            variables: {
                locationId: locationId,
                start: format(start, 'y-MM-dd'),
                end: format(end, 'y-MM-dd'),
                activity: activity || null,
                replacementVehicle: replacementVehicle || null,
                extraJobs: extraJobs || [],
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
    }

    static async availableTimes(locationId: number, date: Date, activity: string, extraJobs: string[]) {
        return await pwaClient.query<AvailableTimesQuery>({
            query: AVAILABLE_TIMES_QUERY,
            variables: {
                locationId: locationId,
                date: format(date, 'y-MM-dd'),
                activity: activity || null,
                extraJobs: extraJobs || [],
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
    }

    static async createAppointment(lead: LeadInput): Promise<FetchResult<CreateAppointmentMutation>> {
        return await pwaClient.mutate<CreateAppointmentMutation>({
            mutation: CREATE_APPOINTMENT,
            variables: {
                lead,
            },
            context: {
                headers: pwaRequestHeaders,
            },
        });
    }
}
